import DetailedOrderReportScreen from './DetailedOrderReportScreen'

export default DetailedOrderReportScreen
